import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Linkify from 'react-linkify';
import Youtubify from 'components/Youtubify';
import ProfileIcon from 'components/ProfileIcon';
import ActionIcon from 'components/ActionIcon';
import Icon, {
  TYPE_LIKE,
  TYPE_PIN,
  TYPE_TRASH,
  TYPE_COMMENT
} from 'components/Icon';
import {
  isUserAdmin,
  canDeletePostOrComment,
  getTooltipMessage
} from 'utils/functions';
import { userShape, wallPostShape } from 'utils/shapes';
import PostAuthor from '../PostAuthor';
import './Post.css';

class Post extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDeleting: false
    };
  }

  deletePost(post) {
    this.setState({ isDeleting: true }, () => {
      this.props.onDeletePost(post);
    });
  }

  render() {
    const {
      post,
      user,
      toggleComments,
      onUnpinWallPost,
      onPinWallPost,
      onLikePost,
      onUnlikePost
    } = this.props;
    const comments = (post.comments && post.comments.comments) || [];

    let likeLabel =
      (post.likeCount ? post.likeCount + ' ' : '') +
      'Like' +
      (post.likeCount > 1 ? 's' : '');
    let commentLabel =
      (post.commentCount ? post.commentCount + ' ' : '') +
      'Comment' +
      (post.commentCount > 1 ? 's' : '');
    const postActions = (
      <div className="feed-message-icon-container">
        {isUserAdmin(user) && (
          <Icon
            type={TYPE_PIN}
            onClick={() => {
              post.isPinned ? onUnpinWallPost(post) : onPinWallPost(post);
            }}
            filled={post.isPinned}
            name="small"
          />
        )}
        {canDeletePostOrComment(user, post) && (
          <Icon
            type={TYPE_TRASH}
            onClick={() => {
              !this.state.isDeleting && this.deletePost(post);
            }}
            disabled={this.state.isDeleting}
            name="post"
          />
        )}
        <ActionIcon
          count={post.likeCount}
          label={likeLabel}
          tooltipMessage={getTooltipMessage(post.likedBy, object => {
            return object.displayName;
          })}
          title="Like this post"
          filled={post.likedByMe}
          type={TYPE_LIKE}
          onClick={() =>
            post.likedByMe ? onUnlikePost(post) : onLikePost(post)}
        />
        <ActionIcon
          count={post.commentCount}
          label={commentLabel}
          tooltipMessage={getTooltipMessage(comments, object => {
            return object.author.displayName;
          })}
          onClick={() => toggleComments(post.id)}
          type={TYPE_COMMENT}
        />
      </div>
    );

    return (
      <div className="original-feed-message">
        <div className="feed-message-specifics">
          {post.isPinned === true ? (
            <Icon type={TYPE_PIN} name="large" filled={true} disabled={true} />
          ) : (
            <ProfileIcon
              size={50}
              src={post.author.avatarUrl}
              border="border"
            />
          )}
          <PostAuthor post={post} />
        </div>
        <div className="feed-message-body">
          <Youtubify>
            <Linkify>{post.message}</Linkify>
          </Youtubify>
          {post.imageUrl && <img src={post.imageUrl} alt="shared" />}
        </div>
        {postActions}
      </div>
    );
  }
}

Post.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func,
  toggleComments: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func
};

export default Post;



// WEBPACK FOOTER //
// ./src/components/FeedList/Post/index.js